module.exports = __webpack_public_path__ + "img/macau-flag.aae22b71.png";